import { render, staticRenderFns } from "./TaksitTutarinaGoreTaksitlendirme.vue?vue&type=template&id=0e5172b9"
import script from "./TaksitTutarinaGoreTaksitlendirme.vue?vue&type=script&lang=ts"
export * from "./TaksitTutarinaGoreTaksitlendirme.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports